export const Customer_review = [
    { type: 'video', url: require('../../../assets/reviews/customer_review1.mp4') },
    { type: 'video', url: require('../../../assets/reviews/customer_review2.mp4') },
    { type: 'video', url: require('../../../assets/reviews/video1.mp4') },
    { type: 'video', url: require('../../../assets/reviews/video2.mp4') },
];  